import start from './src/start';
import {disableBtnsOnSubmit/*, throwErr*/} from '@massimo-cassandro/m-utilities/js-utilities/form-utilities';
// import toggle_disabled from '@massimo-cassandro/m-utilities/js-utilities/toggle-disabled';

start();
disableBtnsOnSubmit();

(() => {
  const cbox_consensoCessDati = document.getElementById('consensoCessDati');

  if(cbox_consensoCessDati) {
    cbox_consensoCessDati.disabled = true;


    const box_informativa = document.querySelector('.box-info-privacy'),
      end_informativa = document.querySelector('.end-informativa-consenso-cessione-dati');

    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          cbox_consensoCessDati.disabled = false;
          observer.unobserve(end_informativa);
        }
      });
    },
    {
      root: box_informativa,
      rootMargin: '0px',
      threshold: 1.0
    });
    observer.observe(end_informativa);
  }
})();
